export default {
  SET_SIDE_TASK_TYPES(state, payload) {
    state.sideTaskTypes = payload;
  },
};
